
export class Photo {
  /**
   * Unique identifier for this record in the database
   */
  photoId: number;

  /**
   * review this photo is tied to
   */
  reviewId?: number;

  /**
   * Numeric ID of the entity this photo relates to
   */
  entityId: number;

  /**
   * numeric ID of the type of photo this is
   */
  lookupId: number;

  /**
   * path to original photo file
   */
  originalPhotoPath: string;

  /**
   * path to large version of photo
   */
  largePhotoPath: string;

  /**
   * path to medium version of photo
   */
  previewPhotoPath: string;

  /**
   * path to small version of photo
   */
  thumbnailPhotoPath: string;

  /**
   * Date the review was added
   */
  uploadedDate: Date;

  /**
   * MCID of the user who left the review
   */
  recId: string;

  /**
   * Parses review
   * @param data {any} Review data as returned by API
   * @return {Review} Parsed review
   */
  static parse(data: any): Photo {
    return {
      photoId: data.photoId,
      entityId: data.entityId,
      reviewId: data.reviewId,
      lookupId: data.lookupId,
      originalPhotoPath: data.originalPhotoPath,
      largePhotoPath: data.largePhotoPath,
      previewPhotoPath: data.previewPhotoPath,
      thumbnailPhotoPath: data.thumbnailPhotoPath,
      recId: data.uploadedBy,
      uploadedDate: data.uploadedDate ? new Date(data.uploadedDate) : null
    };
  }
}
